<template>
  <Modal
    :value="visible"
    :mask-closable="false"
    :footer-hide="true"
    width="823"
    class-name="invoice-detail-modal"
    @on-visible-change="onVisibleChange"
  >
    <div class="modal-header">
      <span class="modal-title">{{ modalTitle }}</span>
    </div>

    <div class="modal-body">
      <!-- 申请信息 -->
      <div class="section">
        <div class="section-title">申请信息</div>
        <div class="info-list">
          <div class="info-row-status">
            <div class="info-row">
              <span class="info-label">订单编号：</span>
              <span class="info-value">{{ data.order_no || '-' }}</span>
            </div>
            <span v-if="data.status === 1" class="status-tag warn">待开票</span>
            <span v-if="data.status === 3" class="status-tag warn">重新开票</span>
            <span v-if="data.status === 2" class="status-tag success">已开票</span>
            <span v-if="data.status === 4" class="status-tag danger">已驳回</span>
          </div>
          <div class="info-row product-row">
            <span class="info-label">订单商品：</span>
            <div class="product-list">
              <div v-for="(p, idx) in (data.products || [])" :key="idx" class="product-box">
                <img :src="p.product_image | default_img" class="product-img" alt="" />
                <div class="product-info">
                  <div class="product-name">{{ p.product_name || '-' }}</div>
                  <div class="product-spec">{{ p.product_spec || '-' }} <span class="product-spec-num">×{{ p.product_qty || 1 }}</span></div>
                </div>
              </div>
              <div v-if="!(data.products && data.products.length)" class="product-box">
                <img :src="data.product_image | default_img" class="product-img" alt="" />
                <div class="product-info">
                  <div class="product-name">{{ data.product_name || '-' }}</div>
                  <div class="product-spec">{{ data.product_spec || '-' }} <span class="product-spec-num">×{{ data.product_qty || 1 }}</span></div>
                </div>
              </div>
            </div>
          </div>
          <div class="info-row">
            <span class="info-label">买家信息：</span>
            <span class="info-value">{{ data.nickname || '-' }} {{ data.mobile || '' }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">发票抬头：</span>
            <span class="info-value">{{ data.title || '-' }} <span class="copy-link" @click="onCopy(data.title)">复制</span></span>
            
          </div>
          <div class="info-row">
            <span class="info-label">抬头类型：</span>
            <span class="info-value">{{ typeText(data.type) }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">发票类型：</span>
            <span class="info-value">{{ taxTypeText(data.tax_type) }}</span>
          </div>
          <template v-if="data.type === 2">
            <div class="info-row">
              <span class="info-label">税号：</span>
              <span class="info-value">{{ data.tax_number || '-' }}</span>
            </div>
            <div v-if="data.bank_name" class="info-row">
              <span class="info-label">开户银行：</span>
              <span class="info-value">{{ data.bank_name || '-' }}</span>
            </div>
            <div v-if="data.bank_account" class="info-row">
              <span class="info-label">银行账号：</span>
              <span class="info-value">{{ data.bank_account || '-' }}</span>
            </div>
            <div v-if="data.company_address" class="info-row">
              <span class="info-label">企业地址：</span>
              <span class="info-value">{{ data.company_address || '-' }}</span>
            </div>
            <div v-if="data.phone" class="info-row">
              <span class="info-label">企业电话：</span>
              <span class="info-value">{{ data.phone || '-' }}</span>
            </div>
          </template>
          <div class="info-row">
            <span class="info-label">开票金额：</span>
            <span class="info-value">¥{{ data.pay_amount || '0.00' }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">买家邮箱：</span>
            <span class="info-value">{{ data.send_mail || '-' }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">申请时间：</span>
            <span class="info-value">{{ data.create_time || '-' }}</span>
          </div>
        </div>
      </div>

      <!-- 待开票：开票处理 -->
      <div v-if="data.status === 1 || data.status === 3" class="section">
        <div class="section-title">
          开票处理
          <span class="section-sub">（上传发票文件并提交后自动发送至买家邮箱）</span>
        </div>
        <div class="upload-box">
          <div class="upload-label">发票文件 <span class="required">*</span></div>
          <div v-if="!uploadFile" class="upload-area" @click="onUploadClick">
            <span class="upload-icon">+</span>
            <span class="upload-text">上传发票pdf文件</span>
          </div>
          <div v-else class="file-item">
            <img class="file-icon" src="@/assets/images/design/file/pdf.png" alt="" />
            <span class="file-name">{{ uploadFile.name }}</span>
            <span class="file-remove" @click="uploadFile = null">×</span>
          </div>
          <input
            ref="fileInput"
            type="file"
            accept=".pdf"
            style="display: none"
            @change="onFileChange"
          />
        </div>
      </div>

      <!-- 已开票：发票文件展示 -->
      <div v-if="data.status === 2" class="section">
        <div class="section-title">
          开票处理
          <span class="section-sub">（上传发票文件并提交后自动发送至买家邮箱）</span>
        </div>
        <div class="file-show-box">
          <div class="upload-label">发票文件 <span class="required">*</span></div>
          <div class="file-item">
            <img class="file-icon" src="@/assets/images/design/file/pdf.png" alt="图标" />
            <span class="file-name" @click.stop="onDownload">{{ taxFileName }}</span>
            <!-- <span class="file-remove" @click="onRemoveFile">×</span> -->
          </div>
        </div>
        <div class="send-info">
          <span class="send-success">已开票并发送至买家邮箱：{{ data.send_mail }}</span>
          <span class="send-time">{{ data.tax_time }}</span>
        </div>
      </div>

      <!-- 已驳回：驳回信息展示 -->
      <div v-if="data.status === 4" class="section reject-section">
        <div class="section-title">
          开票处理
          <span class="section-sub">（上传发票文件并提交后自动发送至买家邮箱）</span>
        </div>
        <div class="reject-info">
          <div class="reject-content">
            <div class="reject-row">
              <img class="reject-icon" src="@/assets/images/shop-manage/icon-close.png" alt="">
              <div class="reject-title">已驳回</div>
            </div>
            <div class="reject-row">
              <span class="reject-label">驳回原因：</span>
              <span class="reject-value">{{ data.reject_reason || '-' }}</span>
            </div>
            <div class="reject-row">
              <span class="reject-label">驳回备注：</span>
              <span class="reject-value">{{ data.reject_remark || '-' }}</span>
            </div>
            <div class="reject-row">
              <span class="reject-label">驳回时间：</span>
              <span class="reject-value">{{ data.reject_time || '-' }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部按钮 -->
    <div class="modal-footer">
      <template v-if="data.status === 1 || data.status === 3">
        <div class="btn cancel" @click="onCancel">取消</div>
        <div class="btn reject" @click="onReject">驳回</div>
        <div class="btn confirm" :class="{ disabled: !uploadFile }" @click="onConfirm">
          确认开票并提交
        </div>
      </template>
      <template v-if="data.status === 2">
        <div class="btn outline" @click="onDownload">下载发票</div>
        <div class="btn confirm" @click="onCancel">确认</div>
      </template>
      <template v-if="data.status === 4">
        <div class="btn confirm" @click="onCancel">确认</div>
      </template>
    </div>
  </Modal>
</template>

<script>
import { uploadFileToOSS } from '@/utils/oss'
export default {
  name: 'InvoiceDetailModal',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => ({}),
    },
    isPlatform: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      uploadFile: null,
    }
  },
  computed: {
    modalTitle() {
      if (this.isPlatform) {
        return '开票申请详情'
      }
      return '开票申请详情'
    },
    // 发票文件展示名称（取链接中的文件名，缺省兜底）
    taxFileName() {
      const url = this.data.tax_file || ''
      if (!url) return '商品明细发票文件.pdf'
      const name = url.split('?')[0].split('/').pop()
      return name || '商品明细发票文件.pdf'
    },
  },
  watch: {
    visible(val) {
      if (val) {
        this.uploadFile = null
      }
    },
  },
  methods: {
    onVisibleChange(val) {
      this.$emit('update:visible', val)
    },
    typeText(type) {
      return type == 2 ? '企业' : '个人'
    },
    taxTypeText(taxType) {
      return taxType == 1 ? '电子专用发票' : '电子普通发票'
    },
    onCopy(text) {
      if (!text) return
      navigator.clipboard.writeText(text).then(() => {
        this.$layer.msg("复制成功");
      });
    },
    onUploadClick() {
      this.$refs.fileInput.click()
    },
    onFileChange(e) {
      const file = e.target.files[0]
      if (file) {
        this.uploadFile = file
      }
      e.target.value = ''
    },
    onRemoveFile() {
      this.$Modal.confirm({
        title: '确认删除',
        content: '确定删除该发票文件吗？',
        onOk: () => {
          this.uploadFile = null
        },
      })
    },
    onCancel() {
      this.$emit('update:visible', false)
    },
    onReject() {
      this.$emit('reject', this.data)
    },
    async onConfirm() {
      if (!this.uploadFile) {
        this.$Message.warning('请先上传发票文件')
        return
      }
      try {
        const taxFile = await uploadFileToOSS(this.uploadFile, 'shop/invoice')
        this.$emit('confirm', { tax_file: taxFile })
      } catch (e) {
        this.$Message.error('发票文件上传失败，请重试')
      }
    },
    onDownload() {
      this.$emit('download', this.data)
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .invoice-detail-modal {
  text-align: left;
  .ivu-modal-content {
    border-radius: 10px;
  }

  .ivu-modal-body {
    padding: 0;
  }

  .ivu-modal-close {
    top: 16px;
    right: 16px;
  }
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 17px 24px 13px 24px;
  border-bottom: 1px solid #f0f0f0;
  position: relative;

  .modal-title {
    font-size: 18px;
    font-weight: bold;
    color: #0F1115;
  }
}

.modal-body {
  padding: 16px 24px;
  max-height: 70vh;
  overflow-y: auto;

  .section {
    margin-bottom: 24px;

    &:last-child {
      margin-bottom: 0;
    }

    .section-title {
      font-size: 16px;
      line-height: 24px;
      font-weight: bold;
      color: #333333;
      margin-bottom: 16px;
      padding-left: 6px;
      border-left: 3px solid #ff5967;

      .section-sub {
        font-size: 14px;
        line-height: 21px;
        color: #999999;
        font-weight: normal;
        margin-left: 6px;
      }
    }

    .info-list {
      margin-bottom: 20px;
      padding: 20px;
      border: 1px solid #e3e3e3;
      border-radius: 10px 10px 10px 10px;
      .info-row {
        display: flex;
        align-items: flex-start;
        margin-bottom: 12px;
        font-size: 14px;
        &:last-child {
          margin-bottom: 0;
        }

        .info-label {
          color: #999999;
          width: 80px;
          flex-shrink: 0;
        }

        .info-value {
          color: #333333;
          flex: 1;
          .copy-link {
            color: #0d99ff;
            cursor: pointer;
            font-size: 12px;
            margin-left: 8px;
  
            &:hover {
              opacity: 0.8;
            }
          }
        }


        &.product-row {
          .product-list {
            display: flex;
            flex-direction: column;
            gap: 12px;
          }

          .product-box {
            display: flex;
            gap: 10px;

            .product-img {
              width: 60px;
              height: 60px;
              object-fit: cover;
              border-radius: 4px;
              border: 1px solid #f0f0f0;
            }

            .product-info {
              .product-name {
                font-size: 14px;
                color: #333333;
                line-height: 1.5;
              }

              .product-spec {
                font-size: 12px;
                color: #999999;
                margin-top: 4px;
                .product-spec-num {
                  margin-left: 24px;
                }
              }
            }
          }
        }
      }
      .info-row-status {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .status-tag {
          padding: 2px 8px;
          border-radius: 4px;
          font-size: 12px;
      
          &.warn {
            color: #ff5000;
            border: 1px solid #ff5000;
          }
      
          &.success {
            color: #02c160;
            border: 1px solid #02c160;
          }
      
          &.danger {
            color: #ff5967;
            border: 1px solid #ff5967;
          }
        }
      }
    }

    .upload-box {
      display: flex;
      align-items: center;
      gap: 16px;
      .upload-label {
        font-size: 14px;
        color: #333333;
        flex-shrink: 0;

        .required {
          color: #ff5967;
        }
      }

      .upload-area {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        padding: 8px 16px;
        border: 1px solid #0d99ff;
        border-radius: 4px;
        cursor: pointer;
        color: #0d99ff;
        font-size: 14px;

        &:hover {
          background: #f7faff;
        }

        .upload-icon {
          font-size: 18px;
          line-height: 1;
        }
      }

      .file-item {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        padding: 8px 14px;
        background: #f7faff;
        border-radius: 4px;

        .file-icon {
          width: 24px;
          height: 24px;
        }

        .file-name {
          font-size: 14px;
          color: #0d99ff;
          cursor: pointer;
        }

        .file-remove {
          color: #999999;
          cursor: pointer;
          font-size: 16px;
          margin-left: 8px;

          &:hover {
            color: #ff5967;
          }
        }
      }
    }

    .file-show-box {
      display: flex;
      gap: 10px;
      .upload-label {
        flex-shrink: 0;
        font-size: 14px;
        color: #333333;
        line-height: 40px;

        .required {
          color: #ff5967;
        }
      }
      .file-item {
        width: 100%;
        display: inline-flex;
        align-items: center;
        gap: 8px;
        padding: 8px 12px;
        background: #f7faff;
        border-radius: 4px;

        .file-icon {
          width: 24px;
          height: 24px;
        }

        .file-name {
          font-size: 14px;
          color: #0d99ff;
          cursor: pointer;
        }

        .file-remove {
          color: #999999;
          cursor: pointer;
          font-size: 16px;
          margin-left: 8px;

          &:hover {
            color: #ff5967;
          }
        }
      }
    }

    .send-info {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 12px;
      padding: 10px 16px;
      background: #f6fff6;
      border-radius: 4px;

      .send-success {
        font-size: 13px;
        color: #02c160;
      }

      .send-time {
        font-size: 12px;
        color: #999999;
      }
    }
  }

  .reject-section {
    .reject-info {
      display: flex;
      gap: 6px;
      padding: 16px 20px;
      background: rgba(255,80,0,0.1);
      border-radius: 4px;

      

      .reject-content {
        flex: 1;

        .reject-row {
          display: flex;
          align-items: center;
          margin-bottom: 6px;
          font-size: 13px;

          .reject-icon {
            width: 36px;
            height: 36px;
            flex-shrink: 0;
          }
          .reject-title {
            margin-left: 12px;
            font-size: 16px;
            color: #FF5000;
            font-weight: 500;
          }

          .reject-label {
            color: #666666;
            width: 70px;
            flex-shrink: 0;
          }

          .reject-value {
            margin-left: 8px;
            color: #333333;
            flex: 1;
          }
        }
      }
    }
  }
}

.modal-footer {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  padding: 18px 24px 22px 24px;
  border-top: 1px solid #e0e0e0;

  .btn {
    min-width: 120px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    font-size: 14px;
    cursor: pointer;
    padding: 0 20px;

    &.cancel {
      background: #ffffff;
      border: 1px solid #e3e3e3;
      color: #999999;
    }

    &.reject {
      background: #ffffff;
      border: 1px solid #ff5967;
      color: #ff5967;
    }

    &.confirm {
      background: #ff5967;
      color: #ffffff;

      &:hover {
        opacity: 0.9;
      }

      &.disabled {
        background: #f5f5f5;
        color: #999999;
        cursor: not-allowed;
        border: 1px solid #e3e3e3;
      }
    }

    &.outline {
      background: #ffffff;
      border: 1px solid #ff5967;
      color: #ff5967;
    }
  }
}
</style>
